import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { Tooltip } from "react-tooltip";
import { LabelProps } from "../types";
import { STYLE_MAP } from "../styles";

export const Label: FC<LabelProps> = ({
  label,
  name,
  description,
  descriptionType = "icon",
  mode = "light",
  htmlFor = true,
  hideLabel
}) => {
  return (
    <div
      className={`${descriptionType === "icon" ? "flex" : ""} ${
        hideLabel ? "hidden" : ""
      } items-center mb-1`}
    >
      <label
        className={`block text-xs font-medium ${STYLE_MAP[mode]["text"].secondary}`}
        htmlFor={htmlFor ? name : undefined}
      >
        {label}
      </label>
      {description && descriptionType === "icon" ? (
        <>
          <Tooltip
            id={`select-${name}`}
            place="top"
            className="max-w-[300px] text-center text-sm z-10"
          />
          <InformationCircleIcon
            className="h-4 w-4 stroke-gray-500 ml-1"
            data-tooltip-id={`select-${name}`}
            data-tooltip-content={description}
          />
        </>
      ) : (
        <div className="text-sm text-gray-500">{description}</div>
      )}
    </div>
  );
};
